// extracted by mini-css-extract-plugin
export default {"card-info":"styles_card-info__NWIpP","head":"styles_head__IJeIR","icon":"styles_icon__EWvpr"};